import { useRef } from 'react';
import { useTheme } from 'styled-components/macro';
import { IConfirmSettings } from '../../types';
import { Button, Dialog, HStack, Text, VStack } from 'components/ui';

interface Props extends IConfirmSettings {
  show: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

export const DefaultConfirm = (props: Props) => {
  const {
    show,
    title,
    body,
    type,
    confirmText,
    dismissText,
    onConfirm,
    onDismiss,
  } = props;

  const theme = useTheme();
  const panelRef = useRef<HTMLDivElement>(null);

  return (
    <Dialog.Root open={show} onOpenChange={(open) => !open && onDismiss()}>
      <Dialog.Portal>
        <Dialog.Content
          withScrollArrows={false}
          onOpenAutoFocus={(e) => {
            e.preventDefault();
            panelRef.current?.focus();
          }}
        >
          <Dialog.Description hidden>Диалог подтверждения</Dialog.Description>
          <Dialog.Panel
            ref={panelRef}
            tabIndex={-1}
            style={{ width: 450, maxWidth: '100%', outline: 'none' }}
          >
            <VStack padding={theme.spacings.base}>
              <Dialog.Title>{title}</Dialog.Title>

              {body && (
                <Text variant="body-14" color="gray.500">
                  {body}
                </Text>
              )}
              <HStack justify="flex-end" spacing="xs">
                {type !== 'alert' && (
                  <Button
                    mode="neutral"
                    variant="main"
                    size="m"
                    onClick={onDismiss}
                  >
                    {dismissText}
                  </Button>
                )}

                <Button
                  mode={type === 'remove' ? 'error' : 'accent'}
                  variant="main"
                  size="m"
                  onClick={onConfirm}
                >
                  {confirmText}
                </Button>
              </HStack>
            </VStack>
          </Dialog.Panel>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
